import { convertFromRaw } from "draft-js";
import { stateToHTML } from "draft-js-export-html";

function isHtmlString(input) {
  if (typeof input !== "string") return false;
  const tagRegex = /<([a-z][\w-]*)(?:\s[^>]*)?>/i;
  return tagRegex.test(input);
}

function tryParseJson(input) {
  if (typeof input !== "string") return input;
  try {
    const first = JSON.parse(input);
    if (typeof first === "string") {
      try {
        return JSON.parse(first);
      } catch {
        return first;
      }
    }
    return first;
  } catch {
    return input;
  }
}

function escapeHtml(unsafe) {
  return String(unsafe)
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/\"/g, "&quot;")
    .replace(/'/g, "&#039;");
}

function stripAlignmentMarker(text) {
  if (typeof text !== "string") return text;
  try {
    // Remove [[ALIGN:...]] markers from the beginning of the text
    const m = text.match(
      /^\s*\[\[ALIGN:(left|center|right|justify)\]\]\s*\n?/i
    );
    if (m) return text.replace(m[0], "");
    return text;
  } catch (_) {
    return text;
  }
}

export function contentToHtml(content) {
  try {
    let raw = content;
    if (typeof raw === "string") raw = tryParseJson(raw);

    // Draft.js raw
    if (raw && raw.blocks && typeof raw.entityMap !== "undefined") {
      const contentState = convertFromRaw(raw);
      return stateToHTML(contentState, {
        blockStyleFn: (block) => {
          const data = block.getData ? block.getData() : null;
          const align = data && data.get ? data.get("textAlign") : null;
          if (align) {
            return {
              style: { textAlign: String(align) },
            };
          }
          return {};
        },
      });
    }

    // Already HTML
    if (typeof content === "string" && isHtmlString(content)) {
      return stripAlignmentMarker(content);
    }

    // Markdown fallback (**bold**, *italic*, __underline__)
    const cleanContent = stripAlignmentMarker(
      typeof content === "string" ? content : String(content || "")
    );
    const safe = escapeHtml(cleanContent);
    let html = safe;
    html = html.replace(/\*\*(.+?)\*\*/g, "<strong>$1</strong>");
    html = html.replace(/\*(.+?)\*/g, "<em>$1</em>");
    html = html.replace(/__(.+?)__/g, "<u>$1</u>");
    html = html.replace(/\r?\n/g, "<br/>");
    return html;
  } catch {
    const fallback =
      typeof content === "string" ? content : String(content || "");
    return stripAlignmentMarker(fallback);
  }
}

export function htmlToPlainText(html) {
  if (!html) return "";
  const div =
    typeof document !== "undefined" ? document.createElement("div") : null;
  if (!div) return stripAlignmentMarker(String(html));
  div.innerHTML = html;
  const text = div.textContent || div.innerText || "";
  return stripAlignmentMarker(text);
}
